import { CallContent } from "../../../Components/CallApp/CallApp";

export const DublinCallContent: CallContent[] = [
  {
    Contact: "Blocked Number",
    date: "24 Apr 2025",
    time: "3:47am",
    type: "missed",
  },
  {
    Contact: "Mum (Catherine)",
    date: "23 Apr 2025",
    time: "7:15pm",
    type: "incoming",
  },
  {
    Contact: "Robbie Doyle",
    date: "23 Apr 2025",
    time: "4:50pm",
    type: "outgoing",
  },
  {
    Contact: "Orla Hosseini",
    date: "23 Apr 2025",
    time: "2:30pm",
    type: "outgoing",
  },
  {
    Contact: "Dad (Joseph)",
    date: "23 Apr 2025",
    time: "12:05pm",
    type: "incoming",
  },
  {
    Contact: "Elske Van der Meer",
    date: "22 April 2025",
    time: "9:21pm",
    type: "incoming",
  },
  {
    Contact: "Blocked Number",
    date: "22 April 2025",
    time: "6:33am",
    type: "missed",
  },
  {
    Contact: "Sean Finnigan",
    date: "21 Apr 2025",
    time: "11:11pm",
    type: "outgoing",
  },
  {
    Contact: "Aisling Reid (Actor)",
    date: "21 Apr 2025",
    time: "5:45pm",
    type: "outgoing",
  },
  {
    Contact: "Blocked Number",
    date: "20 Apr 2025",
    time: "1:15am",
    type: "missed",
  },
];
